import { Rocket, Megaphone, Code2, Briefcase, Palette, GraduationCap } from "lucide-react";

const CASES = [
  { icon: Code2, title: "Equipos de producto", desc: "Sprints, backlog, bug tracking y release planning en un solo lugar." },
  { icon: Megaphone, title: "Marketing y agencias", desc: "Calendario editorial, campañas, briefs y entregables con clientes." },
  { icon: Briefcase, title: "Operaciones internas", desc: "Procesos repetibles, RH, on-boarding y seguimiento de OKRs." },
  { icon: Palette, title: "Diseño y creativos", desc: "Pipelines de diseño, revisiones, feedback con Markdown y enlaces." },
  { icon: GraduationCap, title: "Educación", desc: "Planes de clase, proyectos grupales, rúbricas y entregas con fecha." },
  { icon: Rocket, title: "Founders y solopreneurs", desc: "Convierte tus ideas en un sistema accionable, sin abrumarte." },
];

const STATS = [
  { value: "12+", label: "Funciones clave" },
  { value: "<1s", label: "Updates en pantalla" },
  { value: "100%", label: "Responsive" },
  { value: "Free", label: "Plan gratuito" },
];

export default function UseCasesSection() {
  return (
    <section className="relative py-20 md:py-28" data-testid="landing-use-cases">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-10 items-end">
          <div>
            <span className="inline-block text-[11px] uppercase tracking-[0.2em] font-semibold text-blue-600 dark:text-blue-400">
              Casos de uso
            </span>
            <h2 className="font-display text-3xl md:text-5xl font-semibold tracking-tight mt-2 leading-[1.05]">
              Pensado para cualquier equipo que necesite orden.
            </h2>
            <p className="text-muted-foreground mt-4 text-base md:text-lg">
              Desde un freelancer organizando su día hasta una empresa coordinando 30 proyectos en paralelo.
            </p>
          </div>
          <div className="grid grid-cols-4 gap-3">
            {STATS.map((s) => (
              <div key={s.label} className="glass-card rounded-2xl p-4 text-center">
                <div className="font-display text-2xl md:text-3xl font-semibold text-blue-600 dark:text-blue-300">{s.value}</div>
                <div className="text-[10px] uppercase tracking-wider text-muted-foreground mt-1 leading-tight">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {CASES.map(({ icon: Icon, title, desc }, i) => (
            <div
              key={title}
              data-testid={`use-case-${i}`}
              className="glass-card rounded-2xl p-6 hover:-translate-y-1 hover:shadow-xl hover:shadow-blue-500/10 transition"
              style={{ animation: "fade-rise 0.6s ease-out both", animationDelay: `${i * 60}ms` }}
            >
              <Icon className="h-7 w-7 text-blue-500" />
              <p className="font-display font-semibold text-lg mt-4">{title}</p>
              <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
